import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { SignInTextCard } from '../SignInTextCard';
import iosImage from '../assets/UCS_Sign_In_iOS_App-color.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'IosSignInTextCard.title',
    defaultMessage: 'Access to SurveyMonkey anytime, anywhere',
    description: '[Type: Header][Vis.: low] -  IosSignInTextCard title',
  },
  MESSAGE: {
    id: 'IosSignInTextCard.message',
    defaultMessage:
      'Easily create surveys and track results on the go with the SurveyMonkey mobile app, now available in the App Store.',
    description: '[Type: Paragraph][Vis.: low] - IosSignInTextCard message',
  },
});

export const IosSignInTextCard: React.FC = () => {
  return (
    <SignInTextCard
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => <img src={iosImage} alt="" aria-hidden="true" />}
    />
  );
};

export default IosSignInTextCard;
